// const API_BASE_URL = 'https://bookmyotservice.pythonanywhere.com';
// const API_BASE_URL = 'https://healthcheckapispereco.azurewebsites.net';
// const API_BASE_URL = "https://8hs7dbb1-8081.inc1.devtunnels.ms";
// const API_BASE_URL = "http://localhost:8081";
const API_BASE_URL = " https://qaadmin.runasp.net/";
const API_NOTIFY_URL = "https://pcwhatsappnotify.azurewebsites.net/";
const JSON_BASE_URL = "https://devapi.perennialcode.in";
// const JSON_BASE_URL = "http://localhost:5000";

export { API_BASE_URL, API_NOTIFY_URL, JSON_BASE_URL };
